<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-card>
        <v-toolbar color="#313a46">
          <v-card-title class="text-h5 white--text">
            Portal {{ portal.descricao }}
          </v-card-title>
        </v-toolbar>

        <v-card-text>
          <v-container>
            <v-form ref="formLogins">
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    :value="itemsForm.login"
                    @input="
                      ($event) => (itemsForm.login = $event?.toUpperCase())
                    "
                    label="Login"
                    :rules="[rules.required]"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="itemsForm.password"
                    label="Senha"
                    :rules="[rules.required]"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    :value="itemsForm.descricao"
                    @input="
                      ($event) => (itemsForm.descricao = $event?.toUpperCase())
                    "
                    label="Descrição"
                    :rules="[rules.required]"
                    required
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            outlined
            class="white--text btn-form"
            color="error"
            @click="closeModal()"
          >
            Fechar
          </v-btn>
          <v-btn
            class="white--text mr-5 btn-form"
            :color="labelBtn == 'Cadastrar' ? '#313a46' : 'warning'"
            @click="createLogin()"
          >
            Cadastrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import toast from "@/commom/toast.js";
import logins from "@/services/http/rpa/Logins";
export default {
  props: {
    portal: {
      type: Object,
    },
    dialog: {
      type: Boolean,
      default: false,
    },
    selectedItem: {},
    labelBtn: {
      type: String,
      default: "",
    },
  },
  data: () => ({
    itemsForm: {
      login: "",
      password: "",
      descricao: "",
      rpa_portal_acesso_id: "",
    },
    rules: {
      required: (value) => !!value || "Campo obrigatório.",
    },
  }),
  methods: {
    async closeModal() {
      this.$refs.formLogins.reset();
      this.$emit("update:dialog", false);
    },
    async createLogin() {
      if (!this.$refs.formLogins.validate()) return;
      this.itemsForm.rpa_portal_acesso_id = this.portal.id;
      try {
        await logins().store(this.itemsForm);
        toast("success", "Login adicionado");
        this.closeModal();
      } catch (err) {
        toast("error", "Erro inesperado");
      } finally {
        this.$emit("updateTableLogins");
      }
    },
  },
  watch: {
    async selectedItem(item) {
      this.itemsForm = item;
    },
  },
};
</script>
